import axios from "@/axios";

export const namespaced = true;
const options = {
    'Content-Type': 'application/json'
};

const PageData =  {
    currentPage: 1,
    pageSize: 5,
    recordCount: 1
}

const DefaultnData = {};

export const state = {
    allBankingOffices: [],
    paginatedBankingOffices: [],
    pagination: PageData,
    status: true
}

export const getters = {
    allBankingOffices: (state) =>  state.allBankingOffices,
    paginatedBankingOffices: (state) =>  state.paginatedBankingOffices,
    pagination: (state) => state.pagination,
}

const mutations = {
    SET_ALL_BANKING_OFFICES(state, response) {
        state.allBankingOffices = response.data
    },

    SET_PAGINATION: (state, data) => {

        state.pagination = {
            currentPage: data.currentPage,
            pageSize: data.pageCount,
            recordCount: data.recordCount,  
        };
    },

    SET_PAGINATED_BANKING_OFFICES(state, data) {
        state.paginatedBankingOffices = data;
    },
}

export const actions = {
    async getPaginatedBankingOffices({ commit, state }, apiInfo) {
        let response = await axios.post(`api/adminbankingoffice/search/paginated`, apiInfo,  { config: { showToast: false } });
        
        commit("SET_PAGINATED_BANKING_OFFICES", response.data.results);
        commit("SET_PAGINATION", response.data);
    },
    async getAllBankingOffices({ commit }, apiInfo) {
    commit("SET_ALL_BANKING_OFFICES",  await axios.post(`api/adminbankingoffice/search`, apiInfo, {config: {showToast:false}}));
    },
}



export default {
    state,
    actions,
    getters,
    mutations,
    namespaced
}